export enum COLUMN_GROUP {
	METRICS = 'Metrics',
	SESSION = 'session',
	SYSTEM = 'system',
	USER = 'user'
}
